// extracted by mini-css-extract-plugin
export var customModal = "CustomModal-module--customModal--808e4";
export var lmsScrollbar = "CustomModal-module--lms-scrollbar--b6d6e";